import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calculator, Loader2 } from "lucide-react";

export const ROIInputForm = ({ inputs, isLoadingPrice, onInputChange, onCalculate }) => {
  const fields = [
    { id: "callsPerWeek", label: "Combien d'appels urgents recevez-vous par semaine ?", testId: "roi-calls-per-week", placeholder: "15" },
    { id: "avgInterventionValue", label: "Valeur moyenne d'une intervention (CHF)", testId: "roi-avg-intervention-value", placeholder: "500" },
    { id: "missedCallsPercent", label: "Pourcentage d'appels manques aujourd'hui (%)", testId: "roi-missed-calls-percent", placeholder: "30", max: 100, hint: "Estimation : 20-40% pour la plupart des entreprises" },
    { id: "recoveredCallsPercent", label: "Taux de recuperation avec la solution (%)", testId: "roi-recovered-calls-percent", placeholder: "80", max: 100, hint: "Notre systeme recupere en moyenne 80% des appels manques" },
  ];

  return (
    <div className="bg-white border-2 border-slate-200 rounded-md p-6 sm:p-8" style={{ boxShadow: "4px 4px 0px rgba(30, 90, 158, 0.1)" }}>
      <h3 className="flex items-center gap-2 text-lg sm:text-xl font-bold text-slate-900 mb-6" style={{ fontFamily: "Barlow, sans-serif" }}>
        <Calculator className="w-5 h-5 text-primary flex-shrink-0" />
        Votre situation actuelle
      </h3>
      <div className="space-y-5">
        {fields.map((f) => (
          <div key={f.id} className="space-y-2">
            <Label htmlFor={f.id} className="text-sm font-semibold text-slate-700">{f.label}</Label>
            <Input
              id={f.id}
              data-testid={f.testId}
              type="number"
              min="0"
              max={f.max}
              value={inputs[f.id]}
              onChange={(e) => onInputChange(f.id, e.target.value)}
              placeholder={f.placeholder}
              className="text-base h-11 border-2 border-slate-200 focus:border-primary focus:ring-primary"
            />
            {f.hint && <p className="text-xs text-slate-500">{f.hint}</p>}
          </div>
        ))}

        {/* Solution price */}
        <div className="space-y-2">
          <Label htmlFor="solutionPrice" className="text-sm font-semibold text-slate-700">
            Investissement mensuel dans la solution (CHF)
          </Label>
          <div className="relative">
            <Input
              id="solutionPrice"
              data-testid="roi-solution-price"
              type="number"
              min="0"
              value={inputs.solutionPrice}
              onChange={(e) => onInputChange("solutionPrice", e.target.value)}
              placeholder="350"
              className="text-base h-11 border-2 border-slate-200 focus:border-primary focus:ring-primary"
              disabled={isLoadingPrice}
            />
            {isLoadingPrice && (
              <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-slate-400" />
            )}
          </div>
        </div>

        <Button
          onClick={onCalculate}
          data-testid="roi-calculate-btn"
          className="w-full bg-primary hover:bg-blue-800 text-white font-bold text-base h-12 rounded-md transition-all"
        >
          <Calculator className="w-5 h-5 mr-2" />
          Calculer mon ROI
        </Button>
      </div>
    </div>
  );
};
